const triggers = [].slice.call(document.querySelectorAll('[data-trigger-fieldset]'));

triggers.forEach((trigger) => {
  const name = trigger.name;
  const items = [].slice.call(document.getElementsByName(name));
  const target = document.querySelector(`[data-fieldset="${trigger.dataset.triggerFieldset}"]`);

  items.forEach((item) => {
    item.addEventListener('change', () => {
      if (item === trigger) {
        target.classList.remove('hide');
      } else {
        target.classList.add('hide');
      }
    });
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/conditionalFieldset.js